<div class="≈flex-1 ≈mr-4 ≈overflow-hidden ≈overflow-ellipsis">
  <input *ngIf="isHostFocused && searchable" #searchInput type="text" class="≈outline-none ≈w-full ≈h-full ≈bg-none
                                         ≈text-default-text disabled:≈text-disabled-text ≈font-apple-system
                                         placeholder:≈text-default-text placeholder:disabled:≈text-disabled-text
                                         placeholder:≈font-apple-system"
         [placeholder]="selectedOption?.host?.nativeElement?.innerText ?? 'Not selected'" [disabled]="disabled"
         [(ngModel)]="searchTerm">

  <ui-text *ngIf="!isHostFocused || !searchable" [mode]="disabled ? 'disabled' : 'default'" whitespace="nowrap">
    {{selectedOption?.host?.nativeElement?.innerText ?? 'Not selected'}}
  </ui-text>
</div>

<ui-spinner *ngIf="loading">

</ui-spinner>

<ui-icon *ngIf="!loading" icon="select" [mode]="disabled ? 'disabled' : 'subdued'" size="large">

</ui-icon>

<div #dropDown
     class="≈bg-surface-default ≈rounded-3 sm:≈rounded md:≈rounded-md ≈max-w-4xl ≈shadow-sm sm:≈shadow md:≈shadow-md
        lg:≈shadow-lg xl:≈shadow-xl ≈transition-all ≈duration-75 ≈overflow-hidden ≈text-sm md:≈text-base xl:≈text-lg ≈font-normal
        ≈text-default-text ≈z-50 focus:≈outline-none ≈fixed"
     [ngClass]="{
        '≈max-h-0': !isHostFocused,
        '≈max-h-120 ≈py-2 md:≈py-3': isHostFocused
    }"
     [style.left.px]="dropdownProperties.left" [style.top.px]="dropdownProperties.top"
     [style.width]="dropdownProperties.width" (mousedown)="$event.preventDefault(); $event.stopPropagation()">

  <ng-content>

  </ng-content>

</div>
